// extracted by mini-css-extract-plugin
export default {"error":"error_error__dujE2","content":"error_content__LgtMO"};